var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-L",
    transform: "translate(-711.000000, -2441.000000)",
    fill: "#242424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(652.000000, 2441.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TWITTER",
    transform: "translate(59.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7124647,3.1621524 C21.7074347,2.5381004 22.4708882,1.54857349 22.8305657,0.369808595 C21.8989871,0.947634525 20.8695652,1.36800289 19.7698615,1.593355 C18.8934059,0.612495486 17.6407359,0 16.2543926,0 C13.5960863,0 11.4393992,2.26074395 11.4393992,5.04875406 C11.4393992,5.44456482 11.4807414,5.82881907 11.5634259,6.19862766 C7.56011851,5.9877212 4.01157583,3.97977609 1.63439675,0.921632358 C1.21959622,1.66991694 0.982567353,2.5381004 0.982567353,3.46262189 C0.982567353,5.21343445 1.83283952,6.75911882 3.12547371,7.66486096 C2.33721491,7.64030336 1.5930545,7.41061755 0.942603183,7.0350307 L0.942603183,7.09714698 C0.942603183,9.5442398 2.60318335,11.5854099 4.80810308,12.0476706 C4.40432715,12.166125 3.97850203,12.2253521 3.53889616,12.2253521 C3.22882933,12.2253521 2.92565286,12.1950163 2.63212292,12.1357891 C3.24536622,14.1408451 5.02308275,15.6013001 7.13153724,15.6403034 C5.48335975,16.9953052 3.4052229,17.8028169 1.14931441,17.8028169 C0.760697306,17.8028169 0.376214428,17.7797039 1.26476607e-12,17.7334778 C2.13188176,19.163597 4.6647833,20 7.38372494,20 C16.2447461,20 21.0886791,12.3076923 21.0886791,5.63524738 C21.0886791,5.41567353 21.0845449,5.19609967 21.0762764,4.98085952 C22.0175016,4.26868906 22.8346999,3.38028169 23.4782609,2.36764175 C22.615586,2.76923077 21.6867636,3.04080896 20.7124647,3.1621524 Z",
    id: "Twitter"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.87a0a79fc34ef4fb6d18d9c427e8ad1e.svg";
export { ForwardRef as ReactComponent };